
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/settings",
      function () {
        return require("private-next-pages/account/settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/settings"])
      });
    }
  